import styled from 'styled-components';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { TextColors, Fonts, Spacings } from '@styles/index';

const H2 = styled.h2`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H2};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  ${({ theme }) => `${theme.breakpoints.down('tablet')} {
      font-size: 24px;
    };`}
  @media only screen and (max-width:47.95em) {
    font-size: 22px;
  }
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default H2;

H2.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

H2.defaultProps = {
  color: TextColors.BLACK,
  lineClamp: null
};
